function isImageUrl(url) {
return /\.(jpe?g|png|webp)(\?.*)?$/i.test(url || "");
}

document.addEventListener("click", (e) => {
const a = e.target.closest("a");
if (!a) return;

const href = a.getAttribute("href");
if (!isImageUrl(href)) return;

// Nur wenn wirklich ein Bild im Link steckt (damit andere Links nicht betroffen sind)
if (!a.querySelector("img")) return;

e.preventDefault();
e.stopPropagation();

let overlay = document.querySelector(".lightbox-overlay");
if (!overlay) {
overlay = document.createElement("div");
overlay.className = "lightbox-overlay";
overlay.innerHTML = `<button class="lightbox-close" aria-label="Schließen">×</button><img alt="">`;
document.body.appendChild(overlay);

overlay.addEventListener("click", (ev) => {
if (ev.target === overlay || ev.target.classList.contains("lightbox-close")) {
overlay.classList.remove("is-open");
}
});

document.addEventListener("keydown", (ev) => {
if (ev.key === "Escape") overlay.classList.remove("is-open");
});
}

overlay.querySelector("img").src = a.href;
overlay.classList.add("is-open");
});